"use strict";

(() => {
  'use strict';

  class KMSelect2Input {
    /**
     * @param {HTMLElement} element
     */
    static makeAlive(element) {
      let item = $(element);
      if (!item.select2) {
        return;
      }
      const config = {
        language: document.documentElement.getAttribute('lang').substring(0, 2),
        width: '100%',
        tags: item.attr('data-tags'),
        dropdownParent: item.parent(),
        closeOnSelect: !item.attr('multiple'),
        ajax: {
          url: item.attr('data-url'),
          dataType: 'json',
          delay: 250,
          data: (params, page) => {
            let ret = {};
            ret[item.attr('data-query-variable')] = params.term;
            return ret;
          },
          processResults: function (data, page) {
            return {
              results: data
            };
          },
          cache: false
        },
        escapeMarkup: function (markup) {
          return markup;
        },
        // let our custom formatter work
        minimumInputLength: 0,
        templateResult: function (result) {
          if (result.loading) {
            return result.text;
          }
          if (!result.subLabel) {
            return '<div>' + (result.value || result.text) + '</div>';
          }
          const resultElement = $('<div>').html(result.value || result.text);
          $('<small class="select2input__subLabel">').text(result.subLabel).appendTo(resultElement);
          return resultElement;
        },
        templateSelection: function (result) {
          return result.value || result.text;
        }
      };
      if (item.attr('data-prompt')) {
        config.placeholder = item.attr('data-prompt');
        config.allowClear = true;
      }
      if (!item.attr('data-url')) {
        delete config.ajax;
      }
      item.select2(config);
    }

    /**
     * @param {HTMLElement|Document} element
     */
    static makeAliveByClassIn(element) {
      var inputs = element?.getElementsByClassName('select2input') ?? [];
      for (var i = 0; i < inputs.length; i++) {
        this.makeAlive(inputs[i]);
      }
    }
  }
  window.KMSelect2Input = KMSelect2Input;
  jQuery(document).ready(() => {
    window.KMSelect2Input.makeAliveByClassIn(document);
  });
})();